import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import "core-js/modules/esnext.global-this.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { ALPHA_MODES } from '@pixi/constants';
import { settings } from '@pixi/settings';
import { BaseImageResource } from './BaseImageResource.mjs';
var ImageResource = /*#__PURE__*/function (_BaseImageResource) {
  _inherits(ImageResource, _BaseImageResource);
  var _super = _createSuper(ImageResource);
  function ImageResource(source, options) {
    var _options$createBitmap;
    var _this;
    _classCallCheck(this, ImageResource);
    options = options || {};
    if (typeof source === "string") {
      var imageElement = new Image();
      BaseImageResource.crossOrigin(imageElement, source, options.crossorigin);
      imageElement.src = source;
      source = imageElement;
    }
    _this = _super.call(this, source);
    if (!source.complete && !!_this._width && !!_this._height) {
      _this._width = 0;
      _this._height = 0;
    }
    _this.url = source.src;
    _this._process = null;
    _this.preserveBitmap = false;
    _this.createBitmap = ((_options$createBitmap = options.createBitmap) !== null && _options$createBitmap !== void 0 ? _options$createBitmap : settings.CREATE_IMAGE_BITMAP) && !!globalThis.createImageBitmap;
    _this.alphaMode = typeof options.alphaMode === "number" ? options.alphaMode : null;
    _this.bitmap = null;
    _this._load = null;
    if (options.autoLoad !== false) {
      _this.load();
    }
    return _this;
  }
  _createClass(ImageResource, [{
    key: "load",
    value: function load(createBitmap) {
      var _this2 = this;
      if (this._load) {
        return this._load;
      }
      if (createBitmap !== void 0) {
        this.createBitmap = createBitmap;
      }
      this._load = new Promise(function (resolve, reject) {
        var source = _this2.source;
        _this2.url = source.src;
        var completed = function completed() {
          if (_this2.destroyed) {
            return;
          }
          source.onload = null;
          source.onerror = null;
          _this2.resize(source.width, source.height);
          _this2._load = null;
          if (_this2.createBitmap) {
            resolve(_this2.process());
          } else {
            resolve(_this2);
          }
        };
        if (source.complete && source.src) {
          completed();
        } else {
          source.onload = completed;
          source.onerror = function (event) {
            reject(event);
            _this2.onError.emit(event);
          };
        }
      });
      return this._load;
    }
  }, {
    key: "process",
    value: function process() {
      var _this3 = this;
      var source = this.source;
      if (this._process !== null) {
        return this._process;
      }
      if (this.bitmap !== null || !globalThis.createImageBitmap) {
        return Promise.resolve(this);
      }
      var createImageBitmap = globalThis.createImageBitmap;
      var cors = !source.crossOrigin || source.crossOrigin === "anonymous";
      this._process = fetch(source.src, {
        mode: cors ? "cors" : "no-cors"
      }).then(function (r) {
        return r.blob();
      }).then(function (blob) {
        return createImageBitmap(blob, 0, 0, source.width, source.height, {
          premultiplyAlpha: _this3.alphaMode === null || _this3.alphaMode === ALPHA_MODES.UNPACK ? "premultiply" : "none"
        });
      }).then(function (bitmap) {
        if (_this3.destroyed) {
          return Promise.reject();
        }
        _this3.bitmap = bitmap;
        _this3.update();
        _this3._process = null;
        return Promise.resolve(_this3);
      });
      return this._process;
    }
  }, {
    key: "upload",
    value: function upload(renderer, baseTexture, glTexture) {
      if (typeof this.alphaMode === "number") {
        baseTexture.alphaMode = this.alphaMode;
      }
      if (!this.createBitmap) {
        return _get(_getPrototypeOf(ImageResource.prototype), "upload", this).call(this, renderer, baseTexture, glTexture);
      }
      if (!this.bitmap) {
        this.process();
        if (!this.bitmap) {
          return false;
        }
      }
      _get(_getPrototypeOf(ImageResource.prototype), "upload", this).call(this, renderer, baseTexture, glTexture, this.bitmap);
      if (!this.preserveBitmap) {
        var flag = true;
        var glTextures = baseTexture._glTextures;
        for (var key in glTextures) {
          var otherTex = glTextures[key];
          if (otherTex !== glTexture && otherTex.dirtyId !== baseTexture.dirtyId) {
            flag = false;
            break;
          }
        }
        if (flag) {
          if (this.bitmap.close) {
            this.bitmap.close();
          }
          this.bitmap = null;
        }
      }
      return true;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.source.onload = null;
      this.source.onerror = null;
      _get(_getPrototypeOf(ImageResource.prototype), "dispose", this).call(this);
      if (this.bitmap) {
        this.bitmap.close();
        this.bitmap = null;
      }
      this._process = null;
      this._load = null;
    }
  }], [{
    key: "test",
    value: function test(source) {
      return typeof HTMLImageElement !== "undefined" && (typeof source === "string" || source instanceof HTMLImageElement);
    }
  }]);
  return ImageResource;
}(BaseImageResource);
export { ImageResource };